import {Component, h, Prop} from '@stencil/core';

@Component({
    tag: 'empty-cart-template',
    styleUrl: 'style.sass',
    shadow: true,
})
export class EmptyCartTemplate {
    @Prop() titleText: string;
    @Prop() hintText: string;

    render() {
        return (
            <div class="EmptyContainer">
                <rentware-spacer size="XL" />

                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="28" cy="28" r="28" fill="#F0F0F2" />
                    <path d="M4 35H15.5788C16.6626 35 17.6622 35.5846 18.1935 36.5292L19.4731 38.8041C20.0045 39.7487 21.0041 40.3333 22.0879 40.3333H33.9121C34.9959 40.3333 35.9955 39.7487 36.5269 38.8041L37.8065 36.5292C38.3378 35.5846 39.3374 35 40.4212 35H52V48C52 49.6569 50.6569 51 49 51H7C5.34315 51 4 49.6569 4 48V35Z" fill="white" />
                    <path d="M17.3333 29L4 35H15.5788C16.6626 35 17.6622 35.5846 18.1935 36.5292L19.4731 38.8041C20.0045 39.7487 21.0041 40.3333 22.0879 40.3333H33.9121C34.9959 40.3333 35.9955 39.7487 36.5269 38.8041L37.8065 36.5292C38.3378 35.5846 39.3374 35 40.4212 35H52L38.6667 29H17.3333Z" fill="#E2E2E6" />
                    <path d="M4 35V46C4 48.7614 6.23858 51 9 51H47C49.7614 51 52 48.7614 52 46V35M4 35L17.3333 29H38.6667L52 35M4 35H15.5788C16.6626 35 17.6622 35.5846 18.1935 36.5292L19.4731 38.8041C20.0045 39.7487 21.0041 40.3333 22.0879 40.3333H33.9121C34.9959 40.3333 35.9955 39.7487 36.5269 38.8041L37.8065 36.5292C38.3378 35.5846 39.3374 35 40.4212 35H52" stroke="#625F74" stroke-width="2" />
                    <path d="M28 19V11" stroke="#625F74" stroke-width="2" stroke-linecap="round" />
                    <path d="M19.3335 21.2617L15.3335 14.3335" stroke="#625F74" stroke-width="2" stroke-linecap="round" />
                    <path d="M36.6665 21.2617L40.6665 14.3335" stroke="#625F74" stroke-width="2" stroke-linecap="round" />
                </svg>

                <rentware-spacer size="S" />

                <p class="EmptyTitle">
                    {this.titleText}
                </p>

                <p>
                    {this.hintText}
                </p>

                <rentware-spacer size="L" />
            </div>
        )
    }
}
